import { CdkFooterCell, CdkFooterCellDef } from '@angular/cdk/table';
import { Directive, HostBinding } from '@angular/core';

/**
 * Footer cell definition for the table.
 * Captures the template of a column's footer cell and as well as cell-specific properties.
 */
@Directive({
  selector: '[nFooterCellDef]',
  providers: [{ provide: CdkFooterCellDef, useExisting: NFooterCellDefDirective }],
})
export class NFooterCellDefDirective extends CdkFooterCellDef {}

/** Footer cell template container that adds the right classes and role. */
@Directive({
  selector: 'n-footer-cell, th[n-footer-cell]',
})
export class NFooterCellDirective extends CdkFooterCell {
  @HostBinding('attr.class') class = 'n-footer-cell';
  @HostBinding('attr.role') role = 'columnfooter';
}
